import { useEffect } from "react";
import { useSignalR } from "../hooks/useSignalR";
import Swal from "sweetalert2";

const NotificationListener = () => {
  const signalR = useSignalR();

  useEffect(() => {
    signalR.on("notificationHub", "ShiftEndingSoon", (data) => {
      Swal.fire({
        title: "Notification",
        text: data.message,
        icon: "warning",
        confirmButtonText: "OK",
        

      });
    });
    signalR.on("notificationHub", "ReceiveNotification", (data) => {

      Swal.fire({
        title: "Notification lokesh",
        text: data.message,
        icon: "warning",
        confirmButtonText: "OK",
            customClass: {
          popup: "my-popupsla",
          title: "my-titlesla",
          htmlContainer: "my-textsla",
          confirmButton: "my-confirm-btnsla btn py-2 px-3  btn-primary btn-primary",
        },

      });
    });
    signalR.on("notificationHub", "BellReceiveNotification", (data) => {

      window.dispatchEvent(
        new CustomEvent("bell_notification", { detail: data })
      );
    });

    return () => {
      signalR.off("notificationHub", "ShiftEndingSoon");
      signalR.off("notificationHub", "ReceiveNotification");
      signalR.off("notificationHub", "BellReceiveNotification");
    };
  }, [signalR]);

  return null; // No UI
};

export default NotificationListener;